import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  TextField,
  Typography,
} from '@mui/material'

export type MeterReaderFormType = {
  office: string
  name: string
  code: string
  active: boolean
}

export type MeterReaderFormErrorsType = {
  name: string
  code: string
}

type Props = {
  open: boolean
  isEditMode: boolean
  form: MeterReaderFormType
  errors: MeterReaderFormErrorsType
  onClose: () => void
  onChange: (field: keyof MeterReaderFormType, value: string | boolean) => void
  onSubmit: () => void
}

const MeterReaderFormDialog = ({
  open,
  isEditMode,
  form,
  errors,
  onClose,
  onChange,
  onSubmit,
}: Props) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>{isEditMode ? '검침원 수정' : '검침원 등록'}</DialogTitle>

      <DialogContent>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, mt: 1}}>
          <TextField label='사업소' value={form.office} disabled fullWidth />

          <TextField
            label='검침원성명'
            value={form.name}
            fullWidth
            error={!!errors.name}
            helperText={errors.name}
            onChange={(e) => onChange('name', e.target.value)}
          />

          <TextField
            label='검침원코드'
            value={form.code}
            fullWidth
            error={!!errors.code}
            helperText={errors.code}
            onChange={(e) => onChange('code', e.target.value)}
          />

          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <Typography>사용 여부</Typography>
            <Switch
              checked={form.active}
              onChange={(e) => onChange('active', e.target.checked)}
              color='success'
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant='outlined'>
          취소
        </Button>
        <Button onClick={onSubmit} variant='contained'>
          {isEditMode ? '수정' : '저장'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MeterReaderFormDialog
